import { Component, ContentChild, OnDestroy, OnInit, TemplateRef, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { MONIEPOINT_DESIGN_TYPE } from '../../../../shared/constants';
import { UtilityService } from '../../../../core/services/utility.service';
import { CountDown } from '../../../../shared/models/utility.model';
import { SanitizerService } from '@mpt-fo/common/core/services/sanitize-html.service';
import { SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'app-kamona-overlay-dialog-alert',
    templateUrl: './kamona-dialog-alert.component.html',
    styleUrls: ['./kamona-dialog-alert.component.scss'],
})
export class KamonaDialogAlertComponent implements OnInit, OnDestroy {
    alertType: 'success' | 'error' | 'warning' | 'processing' | 'new-success';
    message: SafeHtml;
    message2: string;
    message3: string;
    title: string;
    callback: any;
    content: any;
    canShowLoading: boolean;
    loading: boolean;
    callbackName: string;
    declineText = 'moniepoint.decline';
    submitting: boolean;
    designType: MONIEPOINT_DESIGN_TYPE = MONIEPOINT_DESIGN_TYPE.MONIEPOINT_V2;
    MONIEPOINT_DESIGN_TYPE = MONIEPOINT_DESIGN_TYPE;
    expiryTime: number;
    countDown: CountDown;
    alertDefaults: {
        title;
        message;
        callbackName;
        actionClass;
        extraMessage;
    };
    extraMessage: string;
    @ContentChild(TemplateRef) template: TemplateRef<unknown>;
    expiryTimeText: any;
    readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

    constructor(public modal: NzModalRef, private utility: UtilityService, private sanitizerService: SanitizerService) {}

    ngOnInit(): void {
        this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
        this.alertType = this.modal.componentInstance.alertType;
        this.message = this.sanitizerService.sanitizeHtml(this.modal.componentInstance.message || this.alertDefaults?.message || '');
        this.message2 = this.modal.componentInstance.message2;
        this.message3 = this.modal.componentInstance.message3;
        this.title = this.modal.componentInstance.title;
        this.callback = this.modal.componentInstance.callback;
        this.callbackName = this.modal.componentInstance.callbackName;
        this.canShowLoading = this.modal.componentInstance.canShowLoading;
        this.designType = this.modal.componentInstance.designType;
        this.extraMessage = this.modal.componentInstance.extraMessage;
        this.expiryTimeText = this.modal.componentInstance.expiryTimeText || 'Try again in';
        this.expiryTime = this.modal.componentInstance.expiryTime;
        if (this.expiryTime) {
            this.utility.resetInterval();
            this.utility.startCountDown(this.expiryTime, true);
        }
        this.setAlertDefaults();
        this.utility._countDown$.subscribe((e) => {
            this.countDown = e;
            const stopCountdown = this.countDown.minutes === 0 && this.countDown.seconds === 0;
            if (stopCountdown) {
                this.utility.resetInterval();
            }
        });
    }

    getRefinedTime(value) {
        if (value <= 0) {
            return `00`;
        }
        const refineValue = value > 9 ? value : `0${value}`;
        return refineValue;
    }

    continue() {
        if (this.callback) {
            this.loading = this.canShowLoading;
            this.callback();
        }
        if (!this.canShowLoading) {
            this.modal.destroy();
        }
    }

    confirm() {
        this.submitting = true;
        this.callback();
    }

    setAlertDefaults() {
        switch (this.alertType) {
            case 'success':
                this.alertDefaults = {
                    title: 'moniepoint.success',
                    message: 'moniepoint.action_successful',
                    callbackName: 'moniepoint.continue',
                    actionClass: 'primary',
                    extraMessage: '',
                };
                break;
            case 'new-success':
                this.alertDefaults = {
                    title: 'moniepoint.success',
                    message: 'moniepoint.action_successful',
                    callbackName: 'moniepoint.continue',
                    actionClass: 'primary',
                    extraMessage: '',
                };
                break;
            case 'error':
                this.alertDefaults = {
                    title: 'moniepoint.operation_failed',
                    message: 'moniepoint.operation_failed',
                    callbackName: 'moniepoint.continue',
                    actionClass: 'decline',
                    extraMessage: '',
                };
                break;
            case 'warning':
                this.alertDefaults = {
                    title: 'moniepoint.operation_failed',
                    message: 'moniepoint.operation_failed',
                    callbackName: 'moniepoint.continue',
                    actionClass: 'red',
                    extraMessage: '',
                };
                break;
            default:
                break;
        }
    }

    ngOnDestroy(): void {
        this.utility.resetInterval();
    }
}
